import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/slice/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";

const AUTO_LOGOUT_TIME = 60 * 60 * 1000; // 1 hour in milliseconds
// const AUTO_LOGOUT_TIME = 2 * 60 * 1000; // 2 minutes in milliseconds

const AuthCheck = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isAuthenticated } = useSelector((state) => state.authSlice);

    const checkLoginDuration = useCallback(() => {
        const loginTime = localStorage.getItem('loginTime');
        if (!loginTime) return;

        const currentTime = new Date().getTime();
        const elapsedTime = currentTime - parseInt(loginTime, 10);

        if (elapsedTime > AUTO_LOGOUT_TIME) {
            dispatch(logout());
            navigate('/');
        }
    }, [dispatch, navigate]);

    useEffect(() => {
        if (!isAuthenticated) return;

        // Check login duration immediately
        checkLoginDuration();

        // Set up an interval to check login duration periodically
        const intervalId = setInterval(checkLoginDuration, 1 * 60 * 1000); // Check every 1 minute

        return () => {
            clearInterval(intervalId);
        };
    }, [dispatch, navigate, isAuthenticated, checkLoginDuration]);

    return null;
};

export default AuthCheck;
